import { TYPE_COLLECTION } from './input-types';

export const id = 'country';
export const apiKey = 'ShipToCountryCode';
export const type = TYPE_COLLECTION;

export const country = {
  id,
  apiKey,
  type,
};
